import Vue from 'vue'
import ls from '@utils/localStore'

const API_BASE_URL = 'http://qa-ai-api.sinog2c.com/api'

export default {
    namespaced: true,
    state: {
        chats: [],
        currentChatId: null
      },
      mutations: {
        ADD_CHAT (state, chat) {
          state.chats.unshift(chat)
          state.currentChatId = chat.id
        },
        DELETE_CHAT (state, chatId) {
          const index = state.chats.findIndex(chat => chat.id === chatId)
          if (index !== -1) {
            state.chats.splice(index, 1)
            // 如果删除的是当前会话，则选中第一个会话
            if (state.currentChatId === chatId && state.chats.length > 0) {
              state.currentChatId = state.chats[0].id
            }
          }
        },
        ADD_MESSAGE (state, { chatId, message }) {
          const chat = state.chats.find(c => c.id === chatId)
          if (chat) {
            chat.messages.push(message)
          }
        },
        UPDATE_LAST_MESSAGE (state, { chatId, content }) {
          const chat = state.chats.find(c => c.id === chatId)
          if (chat && chat.messages.length > 0) {
            const lastMessage = chat.messages[chat.messages.length - 1]
            if (!lastMessage.isUser) {
              // 使用 Vue.set 来确保响应式更新
              Vue.set(lastMessage, 'content', content)
              // 强制更新数组以触发响应式
              chat.messages = [...chat.messages]
            }
          }
        },
        SET_CURRENT_CHAT (state, chatId) {
          state.currentChatId = chatId
        },
        INITIALIZE_CHATS (state) {
          // 从 localStorage 加载聊天记录
          const savedChats = ls.get('chatHistory')
          if (savedChats) {
            state.chats = JSON.parse(savedChats)
          }
        },
        SAVE_CHATS (state) {
          // 保存聊天记录到 localStorage
          ls.set('chatHistory', JSON.stringify(state.chats))
        }
      },
      actions: {
        createNewChat ({ commit }) {
          const newChat = {
            id: Date.now().toString(),
            title: '新对话',
            messages: []
          }
          commit('ADD_CHAT', newChat)
          commit('SAVE_CHATS')
          return newChat.id
        },
        async sendMessage ({ commit, state }, { content, isUser = true }) {
          const message = {
            id: `u_${ Math.random() }`.replace('.', ''),
            content,
            isUser,
            timestamp: new Date().toISOString()
          }
          
          commit('ADD_MESSAGE', {
            chatId: state.currentChatId,
            message
          })
          
          // 保存到 localStorage
          commit('SAVE_CHATS')
          
          // 如果是用户消息，发送到API
          if (isUser) {
            try {
              // 添加一个空的AI响应消息
              const aiMessage = {
                id: Date.now().toString(),
                content: '',
                isUser: false,
                timestamp: new Date().toISOString()
              }
              commit('ADD_MESSAGE', {
                chatId: state.currentChatId,
                message: aiMessage
              })
    
              // 发送请求并处理流式响应
              const response = await fetch(`${API_BASE_URL}/ollama/dify/chat-messages`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  query: content,
                  response_mode: 'streaming',
                  user: 'user-1743127249846',
                  inputs: {},
                  files: []
                })
              })
    
              if (!response.ok) {
                throw new Error('Network response was not ok')
              }
    
              const reader = response.body.getReader()
              const decoder = new TextDecoder()
              let aiResponse = ''
              let isStreaming = true
    
              while (isStreaming) {
                const { done, value } = await reader.read()
                if (done) {
                  isStreaming = false
                  break
                }
    
                const chunk = decoder.decode(value)
                try {
                  const lines = chunk.split('\n')
                  for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        console.log('current line=====', line.slice(6))
                      const data = JSON.parse(line.slice(6))
                      console.log('data.event====', data.event)
                      if (data.event === 'message' && data.answer) {
                        if (/<summary> Thinking\.\.\. <\/summary>$/.test(data.answer)) {
                          data.answer = data.answer.replace(
                            /<summary> Thinking\.\.\. <\/summary>$/,
                            '<summary> 思考中... </summary>'
                          )
                        } else if (/<\/details>$/.test(data.answer)) {
                          aiResponse = aiResponse.replace(
                            /<summary> 思考中\.\.\. <\/summary>/, 
                            '<summary> 回答中... </summary>'
                          )
                        } else if (/\n+/g.test(data.answer)) {
                          data.answer = data.answer.replace(/\n+/g, '<br>')
                        }
                        aiResponse += data.answer
                      } else if (data.event === 'message_end') {
                        aiResponse = aiResponse.replace(
                          /<summary> 回答中\.\.\. <\/summary>/, 
                          '<summary> 回答完成 </summary>'
                        )
                        console.log('333333=====', aiResponse)
                      } 
                      commit('UPDATE_LAST_MESSAGE', {
                        chatId: state.currentChatId,
                        content: aiResponse
                      })
                    }
                  }
                } catch (e) {
                  console.error('Error parsing chunk:', e)
                }
              }
    
              // 更新聊天标题（如果是新对话）
              const currentChat = state.chats.find(c => c.id === state.currentChatId)
              if (currentChat && currentChat.title === '新对话') {
                currentChat.title = content.slice(0, 20) + (content.length > 20 ? '...' : '')
              }
              
              commit('SAVE_CHATS')
            } catch (error) {
              console.error('API请求失败:', error)
              // 更新错误消息
              commit('UPDATE_LAST_MESSAGE', {
                chatId: state.currentChatId,
                content: '抱歉，发送消息时出现错误。'
              })
            }
          }
        },
        initializeChats ({ commit, state, dispatch }) {
          commit('INITIALIZE_CHATS')
          
          // 检查是否有标题为"新对话"的会话
          const hasNewChat = state.chats.some(chat => chat.title === '新对话')
          
          // 如果没有"新对话"，创建一个新的
          if (!hasNewChat) {
            dispatch('createNewChat')
          } else {
            // 如果有"新对话"，将其设置为当前会话
            const newChat = state.chats.find(chat => chat.title === '新对话')
            if (newChat) {
              commit('SET_CURRENT_CHAT', newChat.id)
            }
          }
        }
      },
      getters: {
        currentChat: state => {
          return state.chats.find(chat => chat.id === state.currentChatId)
        },
        chatHistory: state => state.chats
      }
}